import request from '../../utils/request';

export async function getCodeRequest(params) {
  return request({ url: 'sms/code/getCode', method: 'get', headers: 'json', params });
}
export async function getSmsSupplierRequest(params) {
  return request({ url: 'sms/code/getSmsSupplier', method: 'get', headers: 'json', params });
}
export async function switchSupplierRequest(smsSupplierEnum) {
  return request({
    url: `sms/code/switchSupplier?smsSupplierEnum=${smsSupplierEnum}`,
    method: 'put',
    headers: 'json',
  });
}
